import React from 'react';
import useWindowSize from 'react-use/lib/useWindowSize';
import Confetti from 'react-confetti';

interface ConfettiInterface {
  run: boolean;
}

function ConfettiLauncher(props: ConfettiInterface) {
  const {
    run,
  } = props;

  const { width, height } = useWindowSize();

  return (
    <Confetti
      width={width}
      height={height}
      recycle={false}
      numberOfPieces={1000}
      run={run}
    />
  );
}

export default ConfettiLauncher;
